export const toggleHiddenTmpl = (item, classSelector, state) => {
    if (state) {
        document.querySelector(`.${classSelector} [data-status="${item}`).classList.add('hidden');
    } else {
        document.querySelector(`.${classSelector} [data-status="${item}`).classList.remove('hidden');
    }
};

export const toggleValidClass = (item, classSelector, state) => {
    if (state) {
        document.querySelector(`.${classSelector} [data-status="${item}`).classList.add('valid');
    } else {
        document.querySelector(`.${classSelector} [data-status="${item}`).classList.remove('valid');
    }
};
export const checkAdditionalInfo = (value, firstName, lastName, userName, classSelector) => {
    const checkFieldInvalid = (field) => {
        return field && value.search(new RegExp(field, 'i')) > -1;
    };

    if (!(firstName && lastName)) {
        toggleHiddenTmpl('info', classSelector, false);
    } else {
        toggleHiddenTmpl('info', classSelector, true);
    }

    if (Boolean(firstName) && checkFieldInvalid(firstName)) {
        toggleHiddenTmpl('firstName', classSelector, false);
    } else {
        toggleHiddenTmpl('firstName', classSelector, true);
    }

    if (Boolean(lastName) && checkFieldInvalid(lastName)) {
        toggleHiddenTmpl('lastName', classSelector, false);
    } else {
        toggleHiddenTmpl('lastName', classSelector, true);
    }

    if (Boolean(userName) && checkFieldInvalid(userName)) {
        toggleHiddenTmpl('userName', classSelector, false);
    } else {
        toggleHiddenTmpl('userName', classSelector, true);
    }
};

export const checkRegexp = (input, firstName, lastName, userName) => {
    const { value } = input;
    const capitalLetter = new RegExp(/[A-Z]+/g);
    const number = new RegExp(/[0-9]+/g);
    const specialSymbol = new RegExp(/[._$#+%&!?@-]+/g);
    const notSupportedChars = new RegExp(/['()*;§",/]+/g);
    const space = new RegExp(/\s/g);
    const umlaut = new RegExp(/[\u00DF\u00E4\u00F6\u00FC\u00C4\u00D6\u00DC]/g);
    const classSelector = 'passwordHints';
    const minLen = 8;
    const maxLen = 20;

    checkAdditionalInfo(value, firstName, lastName, userName, classSelector);

    if (notSupportedChars.test(value)) {
        toggleHiddenTmpl('notSupportedSymbols', classSelector, false);
    } else {
        toggleHiddenTmpl('notSupportedSymbols', classSelector, true);
    }

    if (specialSymbol.test(value)) {
        toggleValidClass('symbol', classSelector, true);
    } else {
        toggleValidClass('symbol', classSelector, false);
    }

    if (capitalLetter.test(value)) {
        toggleValidClass('letter', classSelector, true);
    } else if (!capitalLetter.test(value)) {
        toggleValidClass('letter', classSelector, false);
    }

    if (number.test(value)) {
        toggleValidClass('number', classSelector, true);
    } else {
        toggleValidClass('number', classSelector, false);
    }

    if (umlaut.test(value)) {
        toggleHiddenTmpl('umlaut', classSelector, false);
    } else {
        toggleHiddenTmpl('umlaut', classSelector, true);
    }

    if (value.length >= minLen && value.length <= maxLen) {
        toggleValidClass('length', classSelector, true);
        toggleHiddenTmpl('maxlength', classSelector, true);
    } else if (value.length > maxLen) {
        toggleHiddenTmpl('maxlength', classSelector, false);
        toggleValidClass('length', classSelector, true);
    } else {
        toggleHiddenTmpl('maxlength', classSelector, true);
        toggleValidClass('length', classSelector, false);
    }

    if (space.test(value)) {
        toggleHiddenTmpl('space', classSelector, false);
    } else {
        toggleHiddenTmpl('space', classSelector, true);
    }
};
